'use client';

import { getENV } from '../../utils/env';
import { useConsentGatedInit } from '../hooks/useConsentGatedInit';

export const OptimizelyV2 = () => {
    const projectID = getENV('NEXT_PUBLIC_OPTIMIZELY_PROJECT_ID');

    useConsentGatedInit({
        src: `https://cdn.optimizely.com/js/${projectID}.js`,
        consentGroup: 'C0002',
    });

    return null;
};
